/**
 * `withholding-types/spec.md` → "Sugerencia de monto por alícuota por defecto":
 * `monto recibido × alícuota / 100`, rounded half up to the cent. The rate is
 * scaled to an integer before dividing so a tie such as 0,5 ¢ never lands on
 * the wrong side of a float error. `null` when the type has no default rate.
 */
export function suggestWithholdingCents(
  receivedCents: number,
  defaultRatePercent: number | null,
): number | null {
  if (defaultRatePercent === null) return null;

  const scaled = Math.round(receivedCents * defaultRatePercent * 100);

  return Math.floor((scaled + 5_000) / 10_000);
}
